export class LoginModel {
    cod_usuario: string;
    usuario: string;
    senha: string;
}